import {
  GETBUSINESSNATURELIST_SUCCESS,
  GETBUSINESSNATURELIST_FAILED,
  RESET_GETBUSINESSNATURELIST,
  LOADING_GETBUSINESSNATURELIST,
  NETWORK_ERROR_GETBUSINESSNATURELIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetBusinessNatureList = () => {
  return { type: RESET_GETBUSINESSNATURELIST };
};

const getBusinessNatureList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETBUSINESSNATURELIST });
  await adminServices
    .post("getBusinessNatureList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getBusinessNatureListsuccess(res.data));
          break;
        default:
          dispatch(getBusinessNatureListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETBUSINESSNATURELIST,
        payload: err,
      });
    });
};
function getBusinessNatureListsuccess(data) {
  return {
    type: GETBUSINESSNATURELIST_SUCCESS,
    payload: data,
  };
}
function getBusinessNatureListFailed(data) {
  return {
    type: GETBUSINESSNATURELIST_FAILED,
    payload: data,
  };
}

export { resetGetBusinessNatureList, getBusinessNatureList };
